export const HeaderTabelCustomerProfile = [
  'Company ID',
  'Company Name',
  'Trade license number',
  'Phone Number',
  'Email',
  'Action',
];
